// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance from "../../../api/adminAxiosInstance";
import { endpoints } from "../../../api/endpoints";

export const GetLogEntrys = createAsyncThunk(
  "logs/LogsEntrys",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.listofsearchlog,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetClientEntrys = createAsyncThunk(
  "logs/GetClientEntrys",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(
        endpoints.getlistofclientlog,
        Data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);




// export const GetLogEntrys = createAsyncThunk(
//   "logs/LogsEntrys",
//   async (Data, { rejectWithValue }) => {
//     try {
//       const response = await adminAxiosInstance.post(
//         endpoints.listofsearchlog,
//         Data
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

const GetLogsEntrys = createSlice({
  name: "GetLogsEntrys",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetLogEntrys.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(GetClientEntrys.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(GetLogEntrys.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(GetClientEntrys.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(GetLogEntrys.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(GetClientEntrys.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default GetLogsEntrys.reducer;
